import { patchUser } from '@api';
import { updateCustomerUser } from '../../customers/_id/users/actions';
import { UpdateUserReferenceRequest } from '@types';
import { updateUserReferences } from '../_idMap/actions';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreUsersByIdPatchSlice = createPatchAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.NAME_UPDATED),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			updateCustomerUser,
			(request) => {
				const update: UpdateUserReferenceRequest = {
					userId: request.userId
				};

				if (request.email) {
					update.email = request.email;
				}

				if (request.firstName) {
					update.firstName = request.firstName;
				}

				if (request.lastName) {
					update.lastName = request.lastName;
				}

				return updateUserReferences([ update ]);
			}
		]
	},
	name: 'CoreUsersById',
	receive: true,
	request: true,
	requestHandler: patchUser,
	retainDataOnRequest: false
});
